import React, { useState, useEffect, useMemo, useLayoutEffect } from "react";

import FilterForm from "app/Components/FilterForm/FilterForm";
import {
  useArea,
  useCategory,
  useContractorDropdown,
  useContractorPersonDropdown,
  useEmployeeDropdown,
} from "app/_helpers/hooks";
import { getAllActivity } from "app/_services/_globalConfiguration/Activity/ActivityService";
import { getAllSites } from "app/_services/ehs/ehsSiteServices";
//import { UserService } from "app/_services/UserService/UserService";
//import { LOGGED_IN_USER_SITE_ID } from "../../IncidentManagement/Helper";
import { userDropdownLabel } from "app/_helpers/helper";
import moment from "moment";
import { LOGGED_IN_USER_SITE_ID } from "app/_pages/_healthSafetyEnvironment/IncidentManagement/Helper";
import { UserService } from "app/_services/UserService/UserService";
import { TRAINEE_TYPE, trainingStatusFilterFields } from "../../CONSTANTS";

export default function TrainingStatusFilters({
  form,
  onChange,
  onReset,
  setForm,
  fields,
  oldStaff = false,
}) {
  const [state, setState] = useState({
    sites: [],
  });

  const [employees, employeesOption] = useEmployeeDropdown(oldStaff ? true : false);
  const [contractorPersons, contractorPersonsOption] = useContractorPersonDropdown(
    oldStaff ? true : false
  );
  const [category, categoryOption] = useCategory("filter[source]=training");
  const [contractors, contractorOption] = useContractorDropdown();

  const [nameList, setNameList] = useState([]);

  useEffect(() => {
    setNameList(
      form?.traineeTypeView === TRAINEE_TYPE.employee
        ? [...employeesOption]
        : form?.traineeTypeView === TRAINEE_TYPE.contractorPerson
        ? [...contractorPersonsOption]
        : [...employeesOption, ...contractorPersonsOption]
    );
  }, [contractorPersonsOption, employeesOption, form?.traineeTypeView]);

  useEffect(() => {
    getAllSites("filter[status]=1").then((response) => {
      if (!response?.data) return;

      setState((prev) => ({
        ...prev,
        //initialActivity: response?.data,
        sites: response.data.map((row) => ({ label: row.name, value: row.id })),
      }));
    });
  }, []);

  const finalFields = useMemo(
    () =>
      (fields || trainingStatusFilterFields).map((f) => {
        const field = { ...f };

        switch (field.name) {
          case "traineeId":
            field.options = nameList;
            break;
          case "trainingCategory":
            field.options = categoryOption;
            break;
          case "siteId":
            field.options = state.sites;
            break;
          case "contractorId":
            field.options = contractors.map((d) => ({
              label: d.contactPerson,
              value: d.id,
            }));
            break;
          default:
            break;
        }

        return field;
      }),
    [fields, nameList, categoryOption, state.sites, contractors]
  );

  return (
    <div className="pb-4">
      <FilterForm
        fields={finalFields}
        form={form}
        onChange={onChange}
        onReset={onReset}
      />
    </div>
  );
}
